import axios from "utils/axios";

/**
 * Повертає список обєктів
 * @param {Object} getData 
 * @param {Number} getData.page
 * @param {string} getData.search
 * @param {string} getData.order
 * @param {array} getData.status
 * @returns 
 */
export const getList = async (getData) => {
    try {
        const response = await axios('/4team/objects', {params:getData});
        return response?.data||null;
    } catch(e){
        console.error(e);
        return null;
    }
} 

/**
 * Повертає інформацію про обєкт
 * @param {Number} objectId 
 * @returns 
 */
export const getById = async (objectId) => {
    try {
        const response = await axios(`/4team/object/${objectId}`);
        return response.data;
    } catch(e){
        console.error(e);
        return null;
    }
}


/**
 * Взяти обєкт в роботу
 * @param {Number} objectId 
 * @returns 
 */
export const takeInWorkObject = async (objectId) => {
    try {
        const response = await axios.post(`/4team/object/inwork/${objectId}`);
        return response?.data||null;
    } catch(e){
        console.error(e);
        return null;
    }
}

/**
 * Взяти обєкт в роботу
 * @param {Number} objectId 
 * @returns 
 */
export const finishedTeamObject = async (objectId) => {
    try {
        const response = await axios.post(`/4team/object/finishedteam/${objectId}`);
        return response?.data||null;
    } catch(e){
        console.error(e);
        return null;
    }
}

/**
 * Повертає повну інформацію по іншим видаткам та надхлодженням
 * @param {Number} objectId 
 * @param {Number} expendId 
 * @returns 
 */
export const getObjectExpend = async (objectId, expendId) => {
    try {
        const response = await axios(`/4team/object/expend/${objectId}/${expendId}`); 
        return response.data;
    } catch(e){
        console.error(e);
        return null;
    }
}


/**
 * Додаємо видатки за послуги на бригаду
 * @param {Object} expendData
 */
export const addService = async (objectId, serviceData) => {
    try {
        const response = await axios.post(`/4team/object/${objectId}/service`, {
            serviceId: Number(serviceData?.serviceId || 0),
            name: serviceData?.name || '',
            count: Number(serviceData?.count || 0),
        });
        return Boolean(response?.data?.stat);
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const addExpend = async (expendData) =>{ 
    try {
        const response = await axios.post(`/4team/object/expend`, expendData);
        return response.data.stat;
    } catch(e){
        console.error(e);
        return false;
    }
}

